"use client";
import React from "react";
import dynamic from "next/dynamic";
const ArticleCarousel = dynamic(() => import("@/components/shelve-article_banner-carousel"), { ssr: false });
import { useMouseMovement } from "@/app/[lang]/MouseMovementContext";

const ArticleLayout = ({
    children,
    articles,
    pathPrefix = "/blogs/editorial",
    display,
    priorityImage,
    loc,
    priorityContent,
}: {
    children?: React.ReactNode;
    articles: any;
    pathPrefix?: string;
    display?: "CARD" | "DEFAULT";
    priorityImage?: boolean;
    loc: string;
    priorityContent?: boolean;
}) => {
    const { hasMouseMoved } = useMouseMovement();
    return (
        <>
            {!hasMouseMoved && !priorityContent ? (
                <div>
                    {articles.map((ac: any, idx: any) => {
                        return (
                            <div key={idx}>
                                <a href={`/blogs/editorial/${ac.handle}`}>
                                    {ac.attributes?.title}
                                    {ac.attributes?.meta_description}
                                </a>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <ArticleCarousel articles={articles} display="CARD" priorityImage={false} loc={loc}>
                    <div></div>
                </ArticleCarousel>
            )}
        </>
    );
};

export default ArticleLayout;
